import { Component, OnInit,ViewChild ,NgModule,Input,Output,EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastComponent } from "../../layout/toast/toast.component";
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
 
export class SigninComponent {

  constructor(
    public httpClient: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
  ){}
  @Input() is_login: boolean;
  @Output() change_status: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
  loading : boolean = false;
  show : boolean = false;
  acc : string = '';
  pwd : string = '';
  msg :string = '';
  show_ams :boolean = true;


  ngOnInit(): void {
   
    if(location.pathname.indexOf('login')!=-1){
      this.show_ams = false;
    }


    if(Dep.islogin()){
      this.gohome();
    }else{
      let token = -1;
      this.route.queryParams.subscribe((queryParams) => {
        if(queryParams['uToken']){
          token = queryParams['uToken'];
          this.ams_login(token);
        }
      }); 
    }
   
  }
  gohome(){
    if(this.show_ams == false){
      this.router.navigate(['/', 'agentmember']);
    }else{
      this.router.navigate(['/', 'home']);
    }

   
    this.change_status.emit(true);
  }
  ams_login(utoken:any){
    console.log('amsinit');
    this.loading = true;
    const body = {utoken: utoken};
    this.httpClient.post<any>("/ams_login.php",body).subscribe(data => {
      this.loading = false;
      if(data.status_code){
        if(data.status_code*1===-1){//需要轉址
          location.href=data.return;
        }else if(data.status_code*1===1){ //成功寫入
          // console.log(data);
          Dep.setData(data.return);
          this.gohome();
        }
      }
      console.log(data);
    });
  }

  go(){
    this.loading = true;
    const body = {token: 'cfd888',acc:this.acc,pwd:this.pwd};
    this.httpClient.post<any>("/signin.php",body).subscribe(data => {
      this.loading = false;
      if(data.status){
        Dep.setData(data.admin_token);
        if(data.identity*1==2){
          this.router.navigate(['/', 'agentmember']);
          this.change_status.emit(true);
        }else if(data.identity*1==3){
            this.router.navigate(['/', 'otagentmember']);
            this.change_status.emit(true);
        }else{
          this.gohome();
        }
      }else{
        this.show_check();
      }
      // console.log(data);
    });
  }

  show_check(){
    this.toastComponent.showMessage('帳號或密碼有誤登入失敗', 'error');
  }
}
